// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"customerSelectAdminHeader_wrapper__1Tola"};